import React from 'react'
import type { ValidatedRecord } from '../../model/types'
import styles from './ImportRecordTable.module.css'

interface Props {
  records: ValidatedRecord[]
  selectedRowKey: string | null
  onSelect: (key: string) => void
}

/** Per-record row representation in the import preview table. */
export const ImportRecordTable: React.FC<Props> = ({ records, selectedRowKey, onSelect }) => {
  if (records.length === 0) {
    return <div className={styles.empty}>표시할 레코드가 없습니다.</div>
  }

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.statusCol}>상태</th>
            <th>시트</th>
            <th>행</th>
            <th>id</th>
            <th>변경/이슈</th>
          </tr>
        </thead>
        <tbody>
          {records.map(r => {
            const key = `${r.record.sheetName}-${r.record.rowNumber}`
            const isSelected = key === selectedRowKey
            return (
              <tr
                key={key}
                className={`${styles.row} ${styles[`row_${r.status}`]} ${isSelected ? styles.selected : ''}`}
                onClick={() => onSelect(key)}
              >
                <td className={styles.statusCol}>
                  <span className={`${styles.badge} ${styles[`badge_${r.status}`]}`}>
                    {r.status === 'valid' ? '✓' : r.status === 'unmatched' ? '⚠' : '✗'}
                  </span>
                </td>
                <td>{r.record.sheetName}</td>
                <td>{r.record.rowNumber}</td>
                <td className={styles.idCell} title={r.record.id}>{r.record.id || '(빈 값)'}</td>
                <td className={styles.detailCell}>{summarize(r)}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

function summarize(r: ValidatedRecord): string {
  if (r.status === 'valid') {
    if (!r.diff || r.diff.changedKeys.length === 0) return '(변경 없음)'
    return `변경: ${r.diff.changedKeys.join(', ')}`
  }
  if (r.status === 'unmatched') return '미매칭: 현재 맵에 없는 id'
  // error
  return r.issues.map(i => i.message).join(' • ')
}
